import { Routes } from '../../nav/routes'
import { ENABLE_CSV } from '../../util/util'
import { footerStrings } from './strings'

export const companyRoles = [
  {
    id: '1',
    text: 'Alliances / Business Development',
  },
  {
    id: '2',
    text: 'Financial Management',
  },
  {
    id: '3',
    text: 'Operations Management',
  },
  {
    id: '4',
    text: 'Product / Project Management',
  },
  {
    id: '5',
    text: 'Tech - Developer / Team lead',
  },
  {
    id: '6',
    text: 'Owner / C-suite',
  },
  {
    id: '7',
    text: 'Other',
  },
]

export const companyAnnualRevenue = [
  {
    id: '1',
    text: '< 1 Crore',
  },
  {
    id: '2',
    text: '1 – 5 Crores',
  },
  {
    id: '3',
    text: '5 – 25 Crores',
  },
  {
    id: '4',
    text: '25 – 50 Crores',
  },
  {
    id: '5',
    text: '> 50 Crores',
  },
]

export const highlightLabelArray = [
  {
    caption: 'Worth of Sales',
    tooltip:
      'Total value of successful transactions before deducting any fees, taxes, refunds, or disputes done during the specified timeframe',
  },
  { caption: 'Transactions', tooltip: 'Total transactions successfully captured during the specified timeframe.' },
  {
    caption: 'Worth of Refunds',
    tooltip: 'Total value of refund requests which have been captured successfully during the specified timeframe.',
  },
  {
    caption: 'Refunds',
    tooltip: 'Total count of refund requests which have been captured successfully during the specified timeframe.',
  },
]

export const refundHighlightLabelArray = [
  {
    caption: 'Refund Initiated',
    tooltip: 'Count of Refund Request Initiated',
  },
  { caption: 'Refund Requested', tooltip: 'Amount of Refund Request Initiated' },
  {
    caption: 'Refund Processed',
    tooltip: 'Amount of Refund request processed',
  },
  {
    caption: 'Success Rate',
    tooltip: 'Success rate of Refund processed',
  },
]

export const SubscriptionDateType = {
  'Subscription Starts': 'Subscription Starts',
  'Subscription Ending': 'Subscription Ending',
  'Subscription Created': 'Subscription Created',
  'Subscription Updated': 'Subscription Updated',
}

export const filterData = {
  transactionStatus: {
    ALL: 'All',
    SUCCESS: 'Success',
    FAILED: 'Failed',
    INPROCESS: 'Inprocess',
  },
  subscriptionPaymentMode: {
    All: 'All',
    Cards: 'Cards',
    UPI: 'UPI',
  },
  paymentMode: {
    ALL: 'All',
    WALLET: 'Wallet',
    UPI: 'Upi',
    DEBIT: 'Debit',
    CREDIT: 'Credit',
    NETBANKING: 'NetBanking',
    STATIC_QR: 'Static Qr',
    DYNAMIC_QR: 'Dynamic QR',
    COLLECT_LINK: 'Collect Link',
    CARDLESS_EMI: 'Cardless EMI',
    PAYLATER: 'Pay Later',
    CC_EMI: 'Credit EMI',
    DC_EMI: 'Debit EMI',
    FOOD_CARD: 'Food Card',
  },
  device: {
    ALL: 'All',
    mobile: 'Mobile',
    web: 'Web',
  },
  product: {
    ALL: 'All',
    SI: 'SI',
    PG: 'PG',
    'Collect link': 'Collect Link',
    Invoice: 'Invoice',
  },
  paymentLinkStatus: {
    ALL: 'All',
    PAID: 'Paid',
    ISSUED: 'Issued',
    CANCELLED: 'Cancelled',
    EXPIRED: 'Expired',
  },
  subscriptionStatus: {
    ALL: 'All',
    Completed: 'Completed',
    Active: 'Active',
    Paused: 'Paused',
    Cancelled: 'Cancelled',
    Failed: 'Failed',
  },
  subscriptionRevocable: {
    'Show All': 'Show All',
    Revocable: 'Revocable',
    'Non-Revocable': 'Non-Revocable',
  },
  subscriptionDateType: SubscriptionDateType,
  campaignType: { All: 'All', 'Instant Discount': 'Instant Discount', Cashback: 'Cashback' },
  campaignStatus: {
    All: 'All',
    Active: 'Active',
    Paused: 'Paused',
    Scheduled: 'Scheduled',
    Completed: 'Completed',
  },
}

export const vaultTxnsFilterData = {
  transactionStatus: {
    ALL: 'All',
    SUCCESS: 'Success',
    FAILED: 'Failed',
    INPROCESS: 'Inprocess',
  },
  subscriptionPaymentMode: {
    All: 'All',
    Cards: 'Cards',
    UPI: 'UPI',
  },
  paymentMode: {
    ALL: 'All',
    DEBIT: 'Debit',
    CREDIT: 'Credit',
    CC_EMI: 'Credit EMI',
    DC_EMI: 'Debit EMI',
  },
  device: {
    ALL: 'All',
    mobile: 'Mobile',
    web: 'Web',
  },
  product: {
    ALL: 'All',
    SI: 'SI',
    PG: 'PG',
    'Collect link': 'Collect Link',
    Invoice: 'Invoice',
  },
  paymentLinkStatus: {
    ALL: 'All',
    PAID: 'Paid',
    ISSUED: 'Issued',
    CANCELLED: 'Cancelled',
    EXPIRED: 'Expired',
  },
  subscriptionStatus: {
    ALL: 'All',
    Completed: 'Completed',
    Active: 'Active',
    Paused: 'Paused',
    Cancelled: 'Cancelled',
    Failed: 'Failed',
  },
  subscriptionRevocable: {
    'Show All': 'Show All',
    Revocable: 'Revocable',
    'Non-Revocable': 'Non-Revocable',
  },
  subscriptionDateType: SubscriptionDateType,
  campaignType: { All: 'All', 'Instant Discount': 'Instant Discount', Cashback: 'Cashback' },
  campaignStatus: {
    All: 'All',
    Active: 'Active',
    Paused: 'Paused',
    Scheduled: 'Scheduled',
    Completed: 'Completed',
  },
}

export const recentsTabData = [{ title: 'Received' }, { title: 'Refunded' }]
export const recentsWebTabData = (
  isTransactionTabEnabled: boolean,
  isSettlementEnabled: boolean,
  isRefundedTabVisible: boolean,
) => {
  const array = []
  if (isTransactionTabEnabled) {
    array?.push({ title: 'Transactions' })
  }
  if (isSettlementEnabled) {
    array?.push({ title: 'Settlements' })
  }
  if (isRefundedTabVisible) {
    array?.push({ title: 'Refunds' })
  }
  return array
}

export const insightsWebTabData = () => {
  const array = []
  array?.push({ title: 'Transactions' })
  array?.push({ title: 'Refunds' })
  return array
}

export const bulkRefundTabData = [{ title: 'File Upload' }, { title: 'History' }]

export const vaultTabData = (isVaultTransactionTabEnabled: boolean) => {
  const retArr = [{ title: 'Tokenisation History' }]
  isVaultTransactionTabEnabled && retArr.push({ title: 'Token Transaction History' })
  return retArr
}
export const refundTabData = (isRefundedTabVisible: boolean, isBulkRefundedTabVisible: boolean) => {
  const array: any = []
  isRefundedTabVisible && array?.push({ title: 'Refund History' })
  isBulkRefundedTabVisible && array?.push({ title: 'Bulk Refund History' })
  return array
}

export const sortPermissionHeader = [
  'Txn Amt',
  'Merchant Ref No',
  'JioPay Id',
  'Txn Date',
  'Txn Status',
  'Bank Ref No',
  'Settlement Ref No',
  'refundAmount',
  'paymentType',
  'settlementReferenceNumber',
  'settledTransactionAmount',
  'settlementDate',
  'settlementRefNo',
  'Created Date',
  'Amount',
  'Request Time',
]

export const subscriptionSearchData = [
  {
    id: '1',
    value: 'Customer Name',
  },
  {
    id: '2',
    value: 'Customer Email',
  },
  {
    id: '3',
    value: 'Customer Mobile Number',
  },
]

export const CALENDER_ID = '6'
export const dateRangeData = [
  {
    id: '1',
    value: 'Today',
  },
  {
    id: '2',
    value: 'Yesterday',
  },
  {
    id: '3',
    value: 'Last 7 Days',
  },
  {
    id: '4',
    value: 'Last 15 Days',
  },
  {
    id: '5',
    value: 'Last 30 Days',
  },
  {
    id: CALENDER_ID,
    value: 'Custom Range',
  },
]

export const receivedDateRange = [
  {
    id: '1',
    value: 'Today',
  },
  {
    id: '2',
    value: 'Yesterday',
  },
  {
    id: '3',
    value: 'Last 7 Days',
  },
  {
    id: '5',
    value: 'Last 30 Days',
  },
  {
    id: CALENDER_ID,
    value: 'Custom Range',
  },
]

export const dateShortRange = [
  {
    id: '1',
    value: 'Today',
  },
  {
    id: '2',
    value: 'This Week',
  },
  {
    id: '3',
    value: 'This Month',
  },
  {
    id: '4',
    value: 'Custom Range',
  },
]

export const SubscriptionDate = {
  starts: 'Subscription Starts',
  ending: 'Subscription Ending',
  created: 'Subscription Created',
  updated: 'Subscription Updated',
}

export const dataExport = [
  {
    id: '1',
    isChecked: true,
    title: 'Excel',
    type: 'XLSX',
  },
  {
    id: '2',
    isChecked: false,
    title: 'Text',
    type: 'TXT',
  },
  {
    id: '3',
    isChecked: false,
    title: 'CSV',
    type: 'CSV',
  },
]

export const exportType = new Map([
  [dataExport[0]?.title, 'XLSX'],
  [dataExport[1]?.title, 'TXT'],
  [dataExport[2]?.title, 'CSV'],
])

export const exportData = (isFromTransactionDetails = false) => {
  return ENABLE_CSV && !isFromTransactionDetails ? dataExport : dataExport?.slice(0, 2)
}

export const settlementFileOptionWithoutCSV = [
  {
    id: '1',
    isChecked: true,
    title: 'Excel',
    type: 'XLSX',
  },
  {
    id: '2',
    isChecked: false,
    title: 'Text',
    type: 'TXT',
  },
  {
    id: '3',
    isChecked: false,
    title: 'Custom',
    type: 'Custom',
  },
]

export const settlementFileOptionsExport = [
  {
    id: '1',
    isChecked: true,
    title: 'Excel',
    type: 'XLSX',
  },
  {
    id: '2',
    isChecked: false,
    title: 'Text',
    type: 'TXT',
  },
  {
    id: '3',
    isChecked: false,
    title: 'Custom',
    type: 'Custom',
  },
  {
    id: '4',
    isChecked: false,
    title: 'CSV',
    type: 'CSV',
  },
  {
    id: '5',
    isChecked: false,
    title: 'Custom-CSV',
    type: 'Custom-CSV',
  },
  {
    id: '6',
    isChecked: false,
    title: 'Custom-Text',
    type: 'Custom-TXT',
  },
]

export const sideMenuBottomData = [
  { id: '7', value: 'FAQs', navigateTo: Routes.FAQS },
  { id: '8', value: 'Help & Support', navigateTo: Routes.HELP_AND_SUPPORT },
]
export const mimeTypes = new Map([
  ['application/vnd.ms-excel', '.xls'],
  ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', '.xlsx'],
  ['application/pdf', '.pdf'],
  ['text/csv', '.csv'],
  ['text/plain', '.txt'],
  ['application/text', '.txt'],
  ['application/octet-stream', '.csv'],
])

export const subscriptionTitleData = {
  // id: '0',
  subscriptionId: 'Subscription Id',
  customerId: 'Customer Id',
  amount: 'Amount',
  type: 'Type',
  frequency: 'Frequency',
  paymentMode: 'Payment Mode',
  startDate: 'Start Date',
  endDate: 'End Date',
  status: 'Status',
  customerName: 'Customer Name',
  email: 'Email',
  mobileNumber: 'Mobile Number',
  createdAt: 'Created At',
  updatedAt: 'Updated At',
  revocable: 'Revocable',
  rrv: 'Rule Recurrence Value',
  jsi: 'JM Subscription Id',
}

export const transactionRecentsTitleDataV2 = {
  // id: '0',
  ERN: 'Merchant Ref No',
  date: 'Txn Date',
  RRN: 'JioPay Id',
  totalAmount: 'Txn Amt',
  transactionStatus: 'Txn Status',
  paymentMode: 'Payment Mode',
}

export const settlementTitleDataV2 = {
  // id: '0',
  fromDate: 'Settlement From Date',
  toDate: 'Settlement To Date',
  referenceNumber: 'Settlement Ref No.',
  action: 'Actions',
  settledTransactionCount: 'Transaction Count',
  settledAmount: 'Transaction Amt',
  refundCount: 'Refund Count',
  refundAmount: 'Refund Amt',
  settlementAmount: 'Settlement Amt',
}

export const initiateRefundTitleDataV2 = {
  // id: '0',
  rrn: 'JioPay Id',
  date: 'Date',
  paymentMode: 'Payment Mode',
  amount: 'Amount',
  grossAmount: 'Original Txn Amt',
  refundAmount: 'Refunded Amount',
  refundProcess: 'Refund Amount',
}

export const initRefundsTitleDataV2WithRb = {
  // id: '0',
  check: 'Select',
  rrn: 'Txn Id',
  date: 'Date',
  paymentMode: 'Mode',
  amount: 'Amount',
  refundAmount: 'Prev. Refunds',
  refundProcess: 'Refund Amount',
  refundInvoiceId: 'Refund Invoice Id',
}

export const initRefundTableFields = [
  'invoice',
  'channel',
  'transactionDateTime',
  'paymentType',
  'cardType',
  'transactionId',
  'transactionDisposition',
  'transactionAmount',
  'refundAmount',
  'sourceSystem',
]
export const initiateRefundTitleDataV2Subscription = {
  // id: '0',
  rrn: 'JioPay Id',
  date: 'Date',
  amount: 'Amount',
  refundAmount: 'Refunded Amount',
  refundProcess: 'Refund Amount',
}

export const initiateRefundStatusDataV2 = {
  // id: '0',
  rrn: 'JioPay Id',
  date: 'Date',
  paymentMode: 'Payment Mode',
  amount: 'Amount',
  grossAmount: 'Original Txn Amt',
  refundAmount: 'Refunded Amount',
  refundStatus: 'Refund Status',
}

export const initiateRefundTitleDataSodexoV2 = {
  // id: '0',
  rrn: 'JioPay Id',
  date: 'Date',
  paymentMode: 'Payment Mode',
  amount: 'Amount',
  grossAmount: 'Original Txn Amt',
  refundAmount: 'Refunded Amount',
  refundProcess: 'Refund Amount',
  refundInvoiceId: 'Refund Invoice Id',
}

export const initiateRefundStatusDataV2Subscription = {
  // id: '0',
  rrn: 'JioPay Id',
  date: 'Date',
  amount: 'Amount',
  refundAmount: 'Refunded Amount',
  refundStatus: 'Refund Status',
}

export const settlementRecentsTitleDataV2 = {
  // id: '0',
  fromDate: 'Settlement From Date',
  toDate: 'Settlement To Date',
  settledTransactionCount: 'Transaction Count',
  settledAmount: 'Settlement Amt',
  file: 'Settlement File Name',
  referenceNumber: 'Settlement Reference Number',
}

export const refundsTitleDataV2 = {
  ERN: 'ERN',
  RRN: 'RRN',
  bankRefNo: 'Bank Ref No.',
  paymentMode: 'Payment Mode',
  paymentType: 'Scheme',
  date: 'Date & Time',
  refundAmount: 'Amount',
  refundStatus: 'Request Status',
}

export const refundsTitleDataV3 = {
  ERN: 'ERN',
  channel: 'CHANNEL',
  RRN: 'RRN',
  bankRefNo: 'Bank Ref No.',
  paymentMode: 'Payment Mode',
  paymentType: 'Scheme',
  date: 'Date & Time',
  refundAmount: 'Amount',
  refundStatus: 'Request Status',
}

export const refundsRecentsTitleDataV2 = {
  // id: '0',
  ERN: 'Merchant Ref No',
  date: 'Txn Date',
  // totalAmount: 'Txn Amt',
  refundAmount: 'Refund Amt',
  refundRequestDate: 'Refund Req Date',
  refundStatus: 'Refund Status',
}

export const refundsProcessedTitleData = {
  id: '0',
  rrn: 'RRN',
  amount: 'Trxn Amount',
  refundAmount: 'Refund Amount',
  transactionStatus: 'STATUS',
  message: 'Remarks',
}

export const refundHeaderData = {
  rrn: 'JioPay Id',
  amount: 'TXN\nAMOUNT',
  refundAmount: 'REFUND\nAMOUNT',
  refundInitiatedDate: 'REFUND\nINITIATED DATE',
  refundStatus: 'REFUND\nSTATUS',
  //refundEndDate: 'REFUNDED TO\nCUSTOMER ON',
  arn: 'ARN',
}

export const splitDetailsHeaderData = {
  splitAmount: 'Split Amount',
  splitInitiatedDate: 'Split Initiated Date',
  benificiaryName: 'Benificiary',
  status: 'Split Status',
}

export const campaignsTitleData = {
  // id: '0',
  cId: 'Campaign Id',
  campaignTitle: 'Campaign Title',
  startDate: 'Start Date',
  endDate: 'End Date',
  status: 'Status',
  rewards: 'Rewards Delivered',
  campaignType: 'Campaign Type',
}

export const paginationSettings = {
  size: 0,
  totalElements: 0,
  totalPages: 0,
  number: 0,
}

export const paginationSettingsWithDefaultPage1 = {
  size: 0,
  totalElements: 0,
  totalPages: 0,
  number: 1,
}

export const filterHeader = ['Payment Method', 'Status', 'Device', 'Product']

export enum MerchantStatus {
  Active = 'Active',
  Inactive = 'Inactive',
  Blocked = 'Blocked',
  Suspend = 'Suspend',
  HotMerchant = 'HotMerchant',
  ClosedByMerchant = 'ClosedByMerchant',
  ClosedByOps = 'ClosedByOps',
}

export enum statusTypes {
  Active = 'Active',
  Inactive = 'Inactive',
  Blocked = 'Blocked',
  Suspend = 'Suspend',
  'Hot Merchant' = 'Hot Merchant',
  'Closed By Merchant' = 'Closed By Merchant',
  'Closed By Ops Team' = 'Closed By Ops Team',
}

export const getMerchantStatusString = {
  [MerchantStatus.Active]: statusTypes.Active,
  [MerchantStatus.Inactive]: statusTypes.Inactive,
  [MerchantStatus.Blocked]: statusTypes.Blocked,
  [MerchantStatus.Suspend]: statusTypes.Suspend,
  [MerchantStatus.HotMerchant]: statusTypes['Hot Merchant'],
  [MerchantStatus.ClosedByMerchant]: statusTypes['Closed By Merchant'],
  [MerchantStatus.ClosedByOps]: statusTypes['Closed By Ops Team'],
}

export const merchantStatusString = {
  Active: statusTypes.Active,
  Inactive: statusTypes.Inactive,
  Blocked: statusTypes.Blocked,
  Suspend: statusTypes.Suspend,
  HotMerchant: statusTypes['Hot Merchant'],
  ClosedByMerchant: statusTypes['Closed By Merchant'],
  ClosedByOps: statusTypes['Closed By Ops Team'],
}

export const statisticsType = {
  Hourly: 'Hourly',
  Daily: 'Daily',
  Weekly: 'Weekly',
  Monthly: 'Monthly',
  Yearly: 'Yearly',
  Date: 'Date',
}

export const footerData = [
  {
    id: footerStrings.whyjio,
    links: [
      {
        value: footerStrings.incCon,
        url: 'conversion',
      },
      {
        value: footerStrings.wide,
        url: 'presence',
      },
      {
        value: footerStrings.risk,
        url: 'secure',
      },
      {
        value: footerStrings.experience,
        url: 'experience',
      },
    ],
  },
  {
    id: footerStrings.products,
    links: [
      {
        value: footerStrings.direct,
        url: 'paydirect',
      },
      {
        value: footerStrings.subscribe,
        url: 'payrepeat',
      },
      {
        value: footerStrings.invoice,
        url: 'paycollect',
      },
      {
        value: footerStrings.market,
        url: 'payonward',
      },
      {
        value: footerStrings.bill,
        url: 'paybills',
      },
    ],
  },
  {
    id: footerStrings.more,
    links: [
      {
        value: footerStrings.terms,
        url: 'privacy',
      },
      {
        value: footerStrings.conditions,
        url: 'tnc',
      },
    ],
  },
]

export const paymentLinksTitleData = {
  // id: '0',
  jioLinkId: 'Jio Link Id',
  createdAt: 'Created Date',
  amount: 'Amount',
  invoice: 'Invoice No',
  pushSmsTo: 'Customer',
  url: 'Payment Link',
  status: 'Status',
}

export const bulkRefundTitleData = {
  // id: '0',
  fileName: 'File Name',
  createdAt: 'File Upload Date',
  count: 'Total Refund Count',
  accepted: 'Accepted Count',
  declined: 'Decline Count',
  status: 'Processing Status',
  actionDownload: 'Actions',
}

export const SubscriptionPaymentTitles = {
  referenceID: 'Reference ID',
  paymentID: 'Payment ID',
  status: 'Status',
  paymentmode: 'Mode of Payment',
  paymentDetails: 'paymentDetails',
  amount: 'Amount',
  addons: 'Addons',
  refund: 'Refund',
  transactionDate: 'Scheduled On',
}

export const subscriptionFields = [
  {
    rank: 1,
    required: false,
    sort: true,
    name: 'Customer Name',
    businessName: 'customerName',
  },
  {
    rank: 2,
    required: false,
    sort: true,
    name: 'Email',
    businessName: 'email',
  },
  {
    rank: 3,
    required: false,
    sort: false,
    name: 'Mobile Number',
    businessName: 'mobileNumber',
  },
  {
    rank: 4,
    required: true,
    sort: true,
    name: 'Status',
    businessName: 'status',
  },
  {
    rank: 5,
    required: false,
    sort: false,
    name: 'Start Date',
    businessName: 'startDate',
  },
  {
    rank: 6,
    required: false,
    sort: false,
    name: 'End Date',
    businessName: 'endDate',
  },
  {
    rank: 7,
    required: false,
    sort: false,
    name: 'Created at',
    businessName: 'createdAt',
  },
  {
    rank: 8,
    required: false,
    sort: false,
    name: 'Updated at',
    businessName: 'updatedAt',
  },
  {
    rank: 9,
    required: false,
    sort: false,
    name: 'Type',
    businessName: 'type',
  },
  {
    rank: 10,
    required: false,
    sort: false,
    name: 'Revocable',
    businessName: 'revocable',
  },
  {
    rank: 11,
    required: false,
    sort: false,
    name: 'Rule Recurrence Value',
    businessName: 'rrv',
  },
  {
    rank: 12,
    required: false,
    sort: false,
    name: 'JM Subscription Id',
    businessName: 'jsi',
  },
]

export const searchFiltersData = [
  { id: '1', value: 'JioPay Id', name: 'JioPay Transaction ID' },
  { id: '2', value: 'Merchant Ref No.', name: 'Merchant Reference Number' },
  { id: '3', value: 'Bank ref No.', name: 'Bank Reference Number' },
  { id: '4', value: 'Customer Id', name: 'Customer ID' },
  { id: '5', value: 'Mobile Number', name: 'Mobile Number' },
  { id: '6', value: 'Email', name: 'Email' },
  { id: '7', value: 'Udf 1', name: 'Udf 1' },
  { id: '8', value: 'Udf 2', name: 'Udf 2' },
  { id: '9', value: 'Udf 3', name: 'Udf 3' },
  { id: '10', value: 'Udf 4', name: 'Udf 4' },
  { id: '11', value: 'Udf 5', name: 'Udf 5' },
  { id: '12', value: 'Terminal Id', name: 'Terminal Id' },
  { id: '13', value: 'Offer Code', name: 'Offer Code' },
//  { id: '14', value: 'Settlement RefNumber', name: 'Settlement RefNumber' },
  { id: '15', value: 'Account Number', name: 'Account Number' },
]

export const initRefundSearchFiltersData = [
  { id: '1', value: 'Merchant Ref No.' },
  { id: '2', value: 'JioPay Id' },
]

export const downloadReportTypeData = [
  {
    id: '0',
    value: 'Transaction',
  },
  {
    id: '1',
    value: 'Settlement',
  },
  {
    id: '2',
    value: 'Refund',
  },
  {
    id: '3',
    value: 'Vault',
  },
]

export const downloadReportsListTitleData = {
  requestFrom: 'Request From',
  requestTo: 'Request To',
  requestTime: 'Request Time',
  status: 'Status',
  downloadDelete: 'Actions',
  fileName: 'File Name',
  requestId: 'Request Id',
}

export const settlementReportsTitleData = {
  // id: '0',
  tableIndex: '#Sr.no',
  reportFormat: 'Format',
  updatedDate: 'Date',
  // name: 'Name',
  reportConfigTitle: 'Title',
  // location: 'Location',
  reportFrequency: 'Frequency',
  actionEditDownload: 'Actions',
}

export const settlementReportAttributesInitData = [
  {
    id: 0,
    attribute: [
      { id: 0, field: 'Payment Id', sequence: 1, aliasName: '', selected: true },
      { id: 1, field: 'Order Id', sequence: 2, aliasName: '', selected: true },
      { id: 2, field: 'Amount', sequence: 3, aliasName: '', selected: true },
      { id: 3, field: 'Status', sequence: 4, aliasName: '', selected: true },
      { id: 4, field: 'Payment method', sequence: 5, aliasName: '', selected: true },
      { id: 5, field: 'Transaction date', sequence: 6, aliasName: '', selected: true },
      { id: 6, field: 'Settlement date', sequence: 7, aliasName: '', selected: true },
      { id: 7, field: 'Description', sequence: 8, aliasName: '', selected: true },
      { id: 8, field: 'Customer e-mail', sequence: 9, aliasName: '', selected: true },
      { id: 9, field: 'Customer Phone', sequence: 10, aliasName: '', selected: true },
      { id: 10, field: 'TXN Fees', sequence: 11, aliasName: '', selected: true },
      { id: 11, field: 'Notes', sequence: 12, aliasName: '', selected: true },
    ],
  },
  {
    id: 1,
    attribute: [
      { id: 0, field: 'Payment Id', sequence: 1, aliasName: '', selected: true },
      { id: 1, field: 'Order Id', sequence: 2, aliasName: '', selected: true },
      { id: 2, field: 'Amount', sequence: 3, aliasName: '', selected: true },
      { id: 3, field: 'Status', sequence: 4, aliasName: '', selected: true },
      { id: 4, field: 'Payment method', sequence: 5, aliasName: '', selected: true },
      { id: 5, field: 'Transaction date', sequence: 6, aliasName: '', selected: true },
      { id: 6, field: 'Settlement date', sequence: 7, aliasName: '', selected: true },
      { id: 7, field: 'Description', sequence: 8, aliasName: '', selected: true },
      { id: 8, field: 'Customer e-mail', sequence: 9, aliasName: '', selected: true },
      { id: 9, field: 'Customer Phone', sequence: 10, aliasName: '', selected: true },
      { id: 10, field: 'TXN Fees', sequence: 11, aliasName: '', selected: true },
      { id: 11, field: 'Notes', sequence: 12, aliasName: '', selected: true },
    ],
  },
]

export const possibleUserPermissionManifest: Array<string> = [
  'Home',
  'Transactions',
  'Refunds',
  'Insights',
  'UPI QR code',
  'Downloads',
  'Settings',
]

export const permissionMapper = (item: any, allowedPermission: Array<string>) => {
  if (item?.permissionCode === 'VIEW_REFUND') {
    allowedPermission?.push('Refunds')
  } else if (
    (item?.permissionCode === 'GET_USER_BY_ENTITY' || item?.permissionCode === 'VIEW_CRED_API') &&
    !allowedPermission.includes('Settings')
  ) {
    allowedPermission?.push('Settings')
  } else if (item?.permissionCode === 'VIEW_TXN_TAB') {
    allowedPermission?.push('Transactions')
  } else if (item?.permissionCode === 'VIEW_INSIGHTS') {
    allowedPermission?.push('Insights')
  } else if (item?.permissionCode === 'VIEW_DOWNLOAD_TAB') {
    allowedPermission?.push('Downloads')
  } else if (
    (item?.permissionCode === 'VIEW_RECENT_TXN' ||
      item?.permissionCode === 'VIEW_HIGHLIGHTS' ||
      item?.permissionCode === 'VIEW_RECENT_REFUND' ||
      item?.permissionCode === 'VIEW_SETTL') &&
    !allowedPermission.includes('Home')
  ) {
    allowedPermission?.push('Home')
  } else if (item?.permissionCode === 'BULK_REFUND') {
    allowedPermission?.push('Refunds')
  } else if (item?.permissionCode === 'VIEW_QR_CODE') {
    allowedPermission?.push('UPI QR code')
  }
  return allowedPermission
}

export const MAX_TRANSACTIONS = Number(window?._env_?.REACT_APP_MAX_TXN_COUNT) ?? 100

export const defaultFields = [
  'transactionDateTime',
  'invoice',
  'transactionId',
  'transactionAmount',
  'transactionDisposition',
  'cardType',
  'paymentType',
  'issRefData',
  'customerName',
  'terminalId',
]

export const REFUND_FIELD_SETTINGS = [
  'transactionDateTime',
  'invoice',
  'refundChannel',
  'transactionId',
  'cardType',
  'paymentType',
  'issRefData',
  'refundAmount',
  'refundStatus',
  'externalReferenceNumber',
]

export const REFUND_FIELD_SETTINGS_DATA = [
  { id: 'invoice', isChecked: true, title: 'Merchant Ref No' },
  { id: 'transactionDateTime', isChecked: true, title: 'Txn Date' },
  { id: 'transactionId', isChecked: true, title: 'Refund Id' },
  { id: 'cardType', isChecked: true, title: 'Payment Mode' },
  { id: 'paymentType', isChecked: true, title: 'Payment Type' },
  { id: 'issRefData', isChecked: true, title: 'Bank Ref No' },
  { id: 'refundAmount', isChecked: true, title: 'Refund Amt' },
  { id: 'refundStatus', isChecked: true, title: 'Refund Status' },
  { id: 'refundChannel', isChecked: true, title: 'Refund Channel' },
  { id: 'externalReferenceNumber', isChecked: true, title: 'ARN' },
]

export const VAULT_TOKEN_TNX_HISTORY_SETTING = [
  'transactionDateTime',
  'invoice',
  'transactionId',
  'transactionAmount',
  'transactionDisposition',
  'cardType',
  'paymentType',
  'issRefData',
]

export const amountColumns = [
  'totalAmount',
  'settledAmount',
  'refundAmount',
  'transactionAmount',
  'settlementAmount',
  'cashbackAmount',
  'originalTxnAmt',
  'amount',
  'instantDiscountAmount',
  'offerTransactionAmount',
  'grossAmount',
]

export const placeholdertextMap = {
  'Merchant Ref No.': 'Enter Merchant Ref. No.',
  'JioPay Id': 'Enter Transaction ID',
  'Bank ref No.': 'Enter Bank Ref. No.',
  'Customer Id': 'Enter Customer ID',
  'Mobile Number': 'Enter Mobile No.',
  Email: 'Enter Email',
  'Card No': 'Enter Card No.',
}
